import React from 'react'
// import { RoutePermittedRole } from 'shared/constants/AppConst';

const UploadBerkas = React.lazy(() => import('./UploadBerkas'))
const DataKeluarga = React.lazy(() => import('./DataKeluarga'))
const DataPribadi = React.lazy(() => import('./DataPribadi'));
const RiwayatHidup = React.lazy(() => import('../RiwayatHidup'));
const PegawaiASN = React.lazy(() => import('./PegawaiASN'))
// const TambahPegawaiASN = React.lazy(() => import('./PegawaiASN/TambahPegawaASN'))
const MenuPegawaiASN = React.lazy(() => import('./PegawaiASN/Menu'))
const DetailPegawaiASN = React.lazy(() => import('./PegawaiASN/Detail'))
const DRH = React.lazy(() => import('./LaporanKhusus/DRH'))
const PegawaiAkanPensiun = React.lazy(() => import('./LaporanKhusus/PegawaiAkanPensiun'))
const LaporanMutasi = React.lazy(() => import('./LaporanKhusus/Mutasi'))
const InformasiJabatan = React.lazy(() => import('./LaporanKhusus/InformasiJabatan'))
const AktivitasOperator = React.lazy(() => import('./LaporanKhusus/AktivitasOperator'))
const SuratDP3 = React.lazy(() => import('./LaporanKhusus/SuratDP3'))
const ExportData = React.lazy(() => import('./LaporanKhusus/ExportData'))
const PegawaiKontrak = React.lazy(() => import('./PegawaiKontrak'))
const PegawaiPJLP = React.lazy(() => import('./PegawaiPJLP'))
const TambahPegawaiJPT = React.lazy(() => import('./PegawaiJPT/TambahPegawai'))
const PegawaiJPT = React.lazy(() => import('./PegawaiJPT'))
const PegawaiIzinBelajar = React.lazy(() => import('./LaporanKhusus/PegawaiIzinBelajar'))
const RekapPegawaiNonPNS = React.lazy(() => import('./LaporanKhusus/RekapPegawaiNonPNS'))
const PegawaiPerluPerbaikan = React.lazy(() => import('./LaporanKhusus/PegawaiPerluPerbaikan'))
const DaftarNominatif = React.lazy(() => import('./LaporanKhusus/Nominatif'))

export const dataPegawaiConfigs = [
  //PEGAWAI
  {
    path: '/pegawai/keluarga',
    element: <DataKeluarga />,
  },
  {
    path: '/pegawai/upload-berkas',
    element: <UploadBerkas />,
  },
  {
    path: '/pegawai/pribadi',
    element: <DataPribadi />,
  },
  {
    path: '/pegawai/pribadi/tab/:tab',
    element: <DataPribadi />,
  },
  {
    path: '/pegawai/pribadi/edit',
    element: <DataPribadi />,
  },
  {
    path: '/pegawai/pribadi/riwayat-hidup',
    element: <RiwayatHidup />,
  },

  //OPERATOR & ADMIN
  {
    path: '/pegawai/asn',
    element: <PegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer'],
  },
  // {
  //   path: '/pegawai/asn/tambah',
  //   element: <TambahPegawaiASN />,
  //   permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  // },
  // {
  //   path: '/pegawai/asn/:id',
  //   element: <MenuPegawaiASN />,
  //   permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  // },
  {
    path: '/pegawai/asn/:id/pokok',
    element: <MenuPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/asn/:id/lainnya/:type',
    element: <MenuPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/asn/:id/keluarga',
    element: <MenuPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/asn/:id/administrasi-kepeg/:type',
    element: <MenuPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/asn/:id/berkas-elektronik',
    element: <MenuPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  // DRH Pegawai ASN
  {
    path: '/pegawai/asn/:nip/detail/drh',
    element: <RiwayatHidup />,
  },
  // Detail Pegawai ASN
  {
    path: '/pegawai/asn/:id/detail/:tab',
    element: <DetailPegawaiASN />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer'],
  },
  // Pegawai Kontrak
  {
    path: '/pegawai/kontrak',
    element: <PegawaiKontrak />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer'],
  },
  {
    path: '/pegawai/kontrak/tambah',
    element: <PegawaiKontrak />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/kontrak/ubah/:id',
    element: <PegawaiKontrak />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  // Pegawai PJLP
  {
    path: '/pegawai/pjlp',
    element: <PegawaiPJLP />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer'],
  },
  {
    path: '/pegawai/pjlp/tambah',
    element: <PegawaiPJLP />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  {
    path: '/pegawai/pjlp/ubah/:nip/:id',
    element: <PegawaiPJLP />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  // JPT Non PNS
  {
    path: '/pegawai/jpt-non-pns',
    element: <PegawaiJPT />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer'],
  },
  {
    path: '/pegawai/jpt-non-pns/tambah',
    element: <TambahPegawaiJPT />,
    permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1'],
  },
  // Laporan Khusus
  {
    path: '/pegawai/laporan-khusus/drh',
    element: <DRH />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/pegawai-akan-pensiun',
    element: <PegawaiAkanPensiun />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/pegawai-tugas-izin-belajar',
    element: <PegawaiIzinBelajar />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/rekapitulasi-pegawai-non-pns',
    element: <RekapPegawaiNonPNS />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/data-pegawai-perlu-diperbaiki',
    element: <PegawaiPerluPerbaikan />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/mutasi',
    element: <LaporanMutasi />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/informasi-jabatan',
    element: <InformasiJabatan />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/aktivitas-operator',
    element: <AktivitasOperator />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/surat-dp3-pegawai',
    element: <SuratDP3 />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/export-data',
    element: <ExportData />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif',
    element: <DaftarNominatif />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif/pejabat-struktural',
    element: <DaftarNominatif />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif/pegawai-nominatif',
    element: <DaftarNominatif />,
    permittedRole: ['Operator', 'Administrator', 'Viewer', 'Operator Eselon 1']
  },

  //Viewer
  {
    path: '/laporan-khusus/drh',
    element: <DRH />,
  },
  {
    path: '/laporan-khusus/pegawai-akan-pensiun',
    element: <PegawaiAkanPensiun />,
  },
  {
    path: '/laporan-khusus/daftar-mutasi',
    element: <LaporanMutasi />,
  },
  {
    path: '/laporan-khusus/export-data',
    element: <ExportData />,
  },
  {
    path: '/laporan-khusus/surat-dp3-pegawai',
    element: <SuratDP3 />,
  },
  {
    path: '/laporan-khusus/pegawai-tugas-izin-belajar',
    element: <PegawaiIzinBelajar />,
  },
  {
    path: '/laporan-khusus/rekapitulasi-pegawai-non-pns',
    element: <RekapPegawaiNonPNS />,
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif',
    element: <DaftarNominatif />,
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif/pejabat-struktural',
    element: <DaftarNominatif />,
  },
  {
    path: '/pegawai/laporan-khusus/daftar-nominatif/pegawai',
    element: <DaftarNominatif />,
  },
];
